// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37JUm","selected":"styles_selected__2h4OQ"};